import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VacationScheduleSupervisor } from 'app/services/edpApiV1/supervisor/vacationsSchedule';
import { RootState } from 'app/store';
import {
  TVacationScheduleSubordinate,
  TVacationScheduleSubordinatePaginated,
} from 'shared/types/vacation-schedule.types';

type TCurrentSubstitutionSchedule = {
  current: VacationScheduleSupervisor | undefined;
};

const initialState: TVacationScheduleSubordinatePaginated & TCurrentSubstitutionSchedule = {
  data: [],
  current: undefined,
  pagination: {
    total: 0,
    size: 10,
    page: 1,
  },
};

export const substitutionsScheduleSlice = createSlice({
  name: 'substitutionsScheduleSlice',
  initialState,
  reducers: {
    setCurrentSchedule: (state, { payload }: PayloadAction<VacationScheduleSupervisor>) => {
      state.current = payload;
    },
  },
});

const substitutionsSchedule = (state: RootState) => state.entities.vacationsSchedule.substitutionsSchedule;
export const getSubstitutionsSchedule = createSelector(substitutionsSchedule, state => state);
export const employeesSchedulePagination = createSelector(substitutionsSchedule, ({ pagination }) => pagination);

export const substitutionsScheduleSliceActions = substitutionsScheduleSlice.actions;
export const reducer = substitutionsScheduleSlice.reducer;
